import axios from 'axios'

export function getMenus ({commit}) {
    axios.get ('/menu')
    .then(res => {
        
        if(res.data){        
             console.log(res.data.menus);
            if(res.data.data.length == 0){
                this._vm.$toastr('error',"Nenhum registro encontrado");                
                commit('menus',[]);
                commit('menusTabela',[]);
            } else {
                commit('menus',res.data.data);
                commit('menusTabela',res.data.menus);
                
                // $('#nestable').nestable({maxDepth:3});		
            }
        }
    }, () => {
        commit('menus',[]);
        this._vm.$toastr('error',"Ocorreu erro na operação, por favor tente novamente.");
    });     
}


export function getMenusArg ({commit},payload) {
    // console.log('PAYLOAD', payload.arg)
    
    
    axios.get (payload.url,  { params: payload.arg})
    .then(res => {
        
        if(res.data){        
            // console.log(res);
            if(!res.data.data || res.data.data.length == 0){
                this._vm.$toastr('error',"Nenhum registro encontrado");
                commit('pagination',{});
                commit('menus',[]);
            }else{
            
                let pagination = {
                    current_page: res.data.meta.current_page,
                    last_page: res.data.meta.last_page,
                    next_page_url: res.data.links.next,
                    prev_page_url: res.data.links.prev
                };

                // console.log('DATA',res.data)
                commit('pagination',pagination);
                commit('menus',res.data.data);
            }
        }
    }, () => {
        
        
        commit('pagination',{});
        commit('menus',[]);
        this._vm.$toastr('error',"Ocorreu erro na operação, por favor tente novamente.");
    });     
}


export function atualizaMenus({commit},menus) {
    
    axios.post('/menu/atualizar', menus )    
    .then(res => {        

        // console.log(res);
        if(res.data && res.data.sucesso){
             commit('data', res.data.data);
             this._vm.$toastr('success',  res.data.mensagem)
        }else{
            // commit('menus',[]);
            this._vm.$toastr('error',"Ocorreu erro na operação, por favor tente novamente.");
        }
    }, () => {
        // commit('menus',[]);
        this._vm.$toastr('error',"Ocorreu erro na operação, por favor tente novamente.");
    })
}

export function getData({commit},payload) {
    commit('disableForm', true);



    const reqMenu = axios.get('/menu/'+payload)
    const reqComboMenu = axios.get('combo/recuperacombotag/tipo_menu?addlinha=S');  //tipo menu
    // const reqEnumStatus = axios.get('enum/recuperaenumtag/status/?addlinha=S');
    

    
    axios.all([reqMenu, reqComboMenu]).then(axios.spread((...responses) => {
        const res = responses[0]
        const combo = responses[1]
        // const enumstatus = responses[2]
        // console.log('COMBO',combo);

    

        //para indicar modo edição
        //this.id_banco_dados = payload.id;
        // console.log(res.data.data);
        if(res.data){
            commit('data', res.data.data);
            commit('tipoMenu', combo.data.combo);
            // commit('enumStatus', enumstatus.data.enum);
            commit('disableForm', false);            
        }else{
            this._vm.$toastr('error',"Ocorreu erro ao carregar os dados, por favor atualize a página.")
        }
    })).catch(() => {
        this._vm.$toastr('error',"Ocorreu erro ao carregar os dados, por favor atualize a página.")
    })
}



export function getCombo({commit}) {
    commit('disableForm', true);

    axios.get('combo/recuperacombotag/tipo_menu?addlinha=S')  //tipo menu
    .then(res => {    
      
        if(res.data){
            commit('tipoMenu', res.data.combo);
            commit('disableForm', false);            
        }else{
            this._vm.$toastr('error',"Ocorreu erro ao carregar os dados, por favor atualize a página.")
        }
    }, () => {
        this._vm.$toastr('error',"Ocorreu erro ao carregar os dados, por favor atualize a página.")
    })

    
    /*const reqComboMenu = axios.get('combo/recuperacombotag/tipo_menu?addlinha=S');  //tipo menu
    const reqEnumStatus = axios.get('enum/recuperaenumtag/status/?addlinha=S');
    

    
    axios.all([ reqComboMenu, reqEnumStatus]).then(axios.spread((...responses) => {

        const combo = responses[0]
        const enumstatus = responses[1]
           
        commit('tipoMenu', combo.data.combo);
        commit('enumStatus', enumstatus.data.enum);
        commit('disableForm', false);

    })).catch(errors => {
        this._vm.$toastr('error',"Ocorreu erro ao carregar os dados, por favor atualize a página.")
    })*/
}


export function saveData({getters,commit}) {
    
    let data = getters.data;
    let url = '/menu';
    let method = 'post';
    if (data.id && data.id!='') {
        url = "/menu/" + data.id
        method = 'put';
    }
    // console.log(data)
    axios({ method, url, data })    
    .then(res => {        

        // console.log(res);
        if(res.data && res.data.sucesso){
             commit('data', res.data.data);
             this._vm.$toastr('success',  "Registro gravado com sucesso.")
        }else{
            this._vm.$toastr('error',"Ocorreu erro ao carregar os dados, por favor atualize a página.")
        }
    }, () => {
        this._vm.$toastr('error',"Ocorreu erro ao carregar os dados, por favor atualize a página.")
    })
}